import { isNil } from "lodash";
import { roundFte } from "src/util/roundingStrategy";

export default (fte) => (isNil(fte) ? null : roundFte(fte));
